export var DBSnapshotType;
(function (DBSnapshotType) {
    DBSnapshotType[DBSnapshotType["DB_SNAPSHOT_TYPE_UNKNOWN"] = 0] = "DB_SNAPSHOT_TYPE_UNKNOWN";
    DBSnapshotType[DBSnapshotType["DB_SNAPSHOT_TYPE_SCANNING"] = 1] = "DB_SNAPSHOT_TYPE_SCANNING";
    DBSnapshotType[DBSnapshotType["DB_SNAPSHOT_TYPE_BACKUP"] = 2] = "DB_SNAPSHOT_TYPE_BACKUP";
})(DBSnapshotType || (DBSnapshotType = {}));
